<template>
  <div class="container p-0 texto-principal">
    <div v-if="hasVerSuplenciasPermission" class="w-100 mb-4">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 w-100 gap-3 px-1">
        <h5 class="text-start m-0 ms-1 d-flex align-items-center gap-2">
          <i class="bi bi-people"></i>
          {{ t('suplencias') }} 
        </h5>

        <div class="d-flex flex-column w-100">
          <div class="d-flex align-items-center justify-content-end gap-2 w-100">
            <button class="btn fondo-terciario texto-principal sombra-sm d-flex align-items-center rounded-3" 
                    :class="{ 'disabled opacity-50': !puedeRetroceder }" 
                    @click.prevent="puedeRetroceder && cambiarPeriodo(-1)" 
                    style="height: 39px;">
              <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)">
                <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div>
              <input 
                type="date" 
                class="form-control form-control-sm sombra-sm p-2 rounded-3" 
                v-model="periodoFiltroDesdeTemp"
                @change="procesarCambioConDelay"
              />
            </div>
            <p class="m-0">{{ $t('al') }}</p>
            <div>
              <input 
                type="date" 
                class="form-control form-control-sm sombra-sm p-2 rounded-3" 
                v-model="periodoFiltroHastaTemp"
                @change="procesarCambioConDelay"
              />
            </div>
            <button class="btn fondo-terciario texto-principal sombra-sm d-flex align-items-center rounded-3" 
                    :class="{ 'disabled opacity-50': !puedeAvanzar }" 
                    @click.prevent="puedeAvanzar && cambiarPeriodo(+1)" 
                    style="height: 39px;">
              <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <p v-if="errorPeriodoMaximo31Dias" class="m-0 text-danger small fs-8 ms-auto mt-1 fw-bold">{{ $t('errorPeriodoMaximo31Dias') }}</p>
          <p v-if="errorDesdeNoMayorHasta" class="m-0 text-danger small fs-8 ms-auto mt-1 fw-bold">{{ $t('errorDesdeNoMayorHasta') }}</p>
        </div>
      </div>

      <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center" style="min-height: 200px;">
        <img src="@/assets/LOADING.gif" style="width: 60px;" alt="Cargando..." />
      </div>

      <div v-if="!loading && !noTieneSuplencias" class="w-100 pb-2">
        <div :style="{ display: 'grid', gridTemplateColumns: `repeat(${cantidadColumnas}, minmax(0, 1fr))`, gap: '0.5rem' }" class="p-1">
          <div v-for="dia in fechasAVisualizar" :key="dia.fecha" class="fondo-terciario rounded sombra-sm p-3 d-flex flex-column">
            
            <div v-if="dia.fecha >= periodoFiltroDesde && dia.fecha <= periodoFiltroHasta" class="text-center mb-3 pb-2 border-bottom borde-secundario">
              <div class="fw-bold texto-principal">{{ $t(dia.nombre) }}</div>
              <div class="small texto-secundario">{{ dia.fechaCorta }}</div>
            </div>

            <div v-if="dia.fecha >= periodoFiltroDesde && dia.fecha <= periodoFiltroHasta" class="d-flex flex-column gap-2 text-start w-100 flex-grow-1">
              <div 
                v-for="suplencia in obtenerSuplenciasDia(dia.fecha)" 
                :key="suplencia.IdSuplencias"
                class="fondo-terciario texto-principal border-start border-4 borde-violeta-3 rounded p-2 sombra w-100 position-relative"
              >
                <div class="d-flex align-items-center justify-content-between gap-1 flex-wrap pe-1">
                  <span class="badge sombra-sm text-white bg-goethe-accent">
                    {{ suplencia.AsignaturaSuplente || suplencia.Asignatura }}
                  </span>
                  <span class="fs-7 fw-bold texto-secundario">
                    {{ $t('hora') }} {{ suplencia.Hora }}
                  </span>
                </div>

                <div class="fs-7 mt-2 d-flex flex-column gap-1 texto-secundario">
                  <div v-if="suplencia.PersonaAusente">
                    <i class="bi bi-person-x"></i> 
                    <strong class="ms-1">{{ $t('reemplazaA') }}:</strong> {{ suplencia.PersonaAusente.Apellido }} {{ suplencia.PersonaAusente.Nombre }}
                  </div>
                  <div v-if="suplencia.AulaSuplencia || suplencia.Aula">
                    <i class="bi bi-door-open"></i> 
                    <strong class="ms-1">{{ $t('aula') }}:</strong> {{ suplencia.AulaSuplencia || suplencia.Aula }}
                  </div>
                  <div v-if="suplencia.ClasesSeparadas">
                    <i class="bi bi-people"></i> 
                    <strong class="ms-1">{{ $t('clases') }}:</strong> {{ formatearClases(suplencia.ClasesSeparadas) }}
                  </div>
                </div>

                <div v-if="suplencia.MotivoAusencia" class="mt-2 pt-2 border-top borde-secundario">
                  <div class="fs-8 text-wrap italic">
                    {{ $t('motivo') }}: {{ suplencia.MotivoAusencia.NombreLargo }}
                  </div>
                </div>

              </div>

              <div v-if="obtenerSuplenciasDia(dia.fecha).length === 0" class="texto-secundario small text-center mt-2 w-100">
                -
              </div>
            </div>

          </div>
        </div>
      </div>

      <div v-if="noTieneSuplencias" class="text-center p-5 fondo-terciario rounded-3 sombra-sm mt-2">
        <i class="bi bi-calendar-check text-success fs-2"></i>
        <p class="m-0 mt-2 texto-secundario">{{ t('sinSuplenciasPeriodo') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'SuplenciasSection',
  props: {
    persona: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n();
    const loading = ref(false);
    const errorPeriodoMaximo31Dias = ref(false);
    const errorDesdeNoMayorHasta = ref(false);
    
    const listaSuplencias = ref([]);
    const noTieneSuplencias = ref(false);
    const hasVerSuplenciasPermission = ref(true); // Ajustar según tus permisos

    // --- Helpers de Formateo ---
    const parseDateLocal = (dateStr) => {
      const [year, month, day] = dateStr.split('-');
      return new Date(year, month - 1, day);
    };
    
    const formatDateLocal = (dateObj) => {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const formatearClases = (clasesStr) => {
      if (!clasesStr) return '';
      return clasesStr.split('~').join(', ');
    };

    const obtenerLunes = (fecha) => {
      const d = new Date(fecha);
      const diaDeLaSemana = d.getDay() === 0 ? 7 : d.getDay();
      d.setDate(d.getDate() - diaDeLaSemana + 1);
      return d;
    };

    // Fechas Iniciales
    const hoy = new Date();
    const lunesInicial = obtenerLunes(hoy);
    const domingoInicial = new Date(lunesInicial);
    domingoInicial.setDate(lunesInicial.getDate() + 6);

    const storedDesde = localStorage.getItem('filtroPeriodoDesdeSuplencias');
    const storedHasta = localStorage.getItem('filtroPeriodoHastaSuplencias');

    const periodoFiltroDesde = ref(storedDesde || formatDateLocal(lunesInicial));
    const periodoFiltroHasta = ref(storedHasta || formatDateLocal(domingoInicial));

    const periodoFiltroDesdeTemp = ref(storedDesde || formatDateLocal(lunesInicial));
    const periodoFiltroHastaTemp = ref(storedHasta || formatDateLocal(domingoInicial));

    const diasSemana = [
      { id: 1, nombre: 'Lunes' }, { id: 2, nombre: 'Martes' }, { id: 3, nombre: 'Miercoles' },
      { id: 4, nombre: 'Jueves' }, { id: 5, nombre: 'Viernes' }, { id: 6, nombre: 'Sábado' },
      { id: 7, nombre: 'Domingo' }
    ];

    // --- INTEGRACIÓN DEL FETCH DE SUPLENCIAS ---
    const fetchSuplencias = async () => {
      if (errorDesdeNoMayorHasta.value || errorPeriodoMaximo31Dias.value) return;
      
      loading.value = true;
      try {
        const respuesta = await api.get(`/api/suplencias/persona/${props.persona.IdPersona}`, {
          params: {
            fechaDesde: periodoFiltroDesde.value,
            fechaHasta: periodoFiltroHasta.value
          }
        });
        
        if (respuesta.data && respuesta.data.length > 0) {
          const suplenciasProcesadas = [];

          respuesta.data.forEach(suplencia => {
            // La fecha viene como "2026-05-18T00:00:00", la cortamos por la 'T' para obtener YYYY-MM-DD
            const fechaString = suplencia.Fecha.split('T')[0];
            
            suplenciasProcesadas.push({
              ...suplencia,
              FechaMapeada: fechaString,
            });
          });

          // Opcional: ordenar por hora para que queden prolijas en el día
          suplenciasProcesadas.sort((a, b) => a.Hora - b.Hora);

          listaSuplencias.value = suplenciasProcesadas;
          noTieneSuplencias.value = false;
        } else {
          listaSuplencias.value = [];
          noTieneSuplencias.value = true;
        }
      } catch (error) {
        console.error("Error al obtener el listado de suplencias:", error);
        listaSuplencias.value = [];
        noTieneSuplencias.value = true;
      } finally {
        loading.value = false;
      }
    };

    const obtenerSuplenciasDia = (fechaString) => {
      return listaSuplencias.value.filter(suplencia => suplencia.FechaMapeada === fechaString);
    };

    const timeoutId = ref(null);

    const procesarCambioFecha = () => {
      const nuevoDesde = periodoFiltroDesdeTemp.value;
      const nuevoHasta = periodoFiltroHastaTemp.value;

      if (!nuevoDesde || !nuevoHasta) return;

      const dDesde = parseDateLocal(nuevoDesde);
      const dHasta = parseDateLocal(nuevoHasta);

      if (dDesde > dHasta) {
        errorDesdeNoMayorHasta.value = true;
        errorPeriodoMaximo31Dias.value = false;
        return;
      } else {
        errorDesdeNoMayorHasta.value = false;
      }

      const diffTime = Math.abs(dHasta - dDesde);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

      if (diffDays > 31) {
        errorPeriodoMaximo31Dias.value = true;
        return;
      } else {
        errorPeriodoMaximo31Dias.value = false;
      }

      periodoFiltroDesde.value = nuevoDesde;
      periodoFiltroHasta.value = nuevoHasta;
      localStorage.setItem('filtroPeriodoDesdeSuplencias', nuevoDesde);
      localStorage.setItem('filtroPeriodoHastaSuplencias', nuevoHasta);

      fetchSuplencias();
    };

    const procesarCambioConDelay = () => {
      if (timeoutId.value) clearTimeout(timeoutId.value);
      timeoutId.value = setTimeout(() => {
        procesarCambioFecha();
      }, 1000);
    };

    const cambiarPeriodo = async (direccion) => {
      if (direccion === 1 && !puedeAvanzar.value) return;
      if (direccion === -1 && !puedeRetroceder.value) return;

      const dDesde = parseDateLocal(periodoFiltroDesdeTemp.value);
      const dHasta = parseDateLocal(periodoFiltroHastaTemp.value);
      
      const diaInicio = dDesde.getDate();
      const diaFin = dHasta.getDate();
      const ultimoDiaMesActual = new Date(dDesde.getFullYear(), dDesde.getMonth() + 1, 0).getDate();

      const esPrimeraQuincena = diaInicio === 1 && diaFin === 15;
      const esSegundaQuincena = diaInicio === 16 && diaFin === ultimoDiaMesActual;
      const esMesCompleto = diaInicio === 1 && diaFin === ultimoDiaMesActual;

      if (esMesCompleto) {
        dDesde.setMonth(dDesde.getMonth() + direccion, 1);
        const ultimoDiaNuevoMes = new Date(dDesde.getFullYear(), dDesde.getMonth() + 1, 0).getDate();
        dHasta.setFullYear(dDesde.getFullYear(), dDesde.getMonth(), ultimoDiaNuevoMes);
      } 
      else if (esPrimeraQuincena || esSegundaQuincena) {
        if (direccion === 1) {
          if (esPrimeraQuincena) {
            dDesde.setDate(16);
            dHasta.setDate(ultimoDiaMesActual);
          } else {
            dDesde.setMonth(dDesde.getMonth() + 1, 1);
            dHasta.setMonth(dHasta.getMonth() + 1, 15);
          }
        } else {
          if (esSegundaQuincena) {
            dDesde.setDate(1);
            dHasta.setDate(15);
          } else {
            dDesde.setMonth(dDesde.getMonth() - 1, 16);
            const ultDiaAnterior = new Date(dDesde.getFullYear(), dDesde.getMonth() + 1, 0).getDate();
            dHasta.setMonth(dHasta.getMonth() - 1, ultDiaAnterior);
          }
        }
      } 
      else {
        const diffTime = Math.abs(dHasta - dDesde);
        const diasRango = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
        dDesde.setDate(dDesde.getDate() + (diasRango * direccion));
        dHasta.setDate(dHasta.getDate() + (diasRango * direccion));
      }

      periodoFiltroDesdeTemp.value = formatDateLocal(dDesde);
      periodoFiltroHastaTemp.value = formatDateLocal(dHasta);

      if (timeoutId.value) clearTimeout(timeoutId.value);
      procesarCambioFecha();
    };

    onMounted(() => {
      fetchSuplencias();
    });

    const cantidadDiasPeriodo = computed(() => {
      const d1 = parseDateLocal(periodoFiltroDesde.value);
      const d2 = parseDateLocal(periodoFiltroHasta.value);
      const diffTime = Math.abs(d2 - d1);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    });

    const puedeAvanzar = computed(() => true); 
    const puedeRetroceder = computed(() => {
      const hace6meses = new Date();
      hace6meses.setMonth(hace6meses.getMonth() - 6);
      return parseDateLocal(periodoFiltroDesde.value) >= hace6meses;
    });

    const cantidadColumnas = computed(() => {
      let maxCols = 5; 
      const inicio = parseDateLocal(periodoFiltroDesde.value);
      const dias = cantidadDiasPeriodo.value;

      for (let i = 0; i < dias; i++) {
        const d = new Date(inicio);
        d.setDate(inicio.getDate() + i);
        const diaSemana = d.getDay() === 0 ? 7 : d.getDay();

        if (diaSemana === 6 || diaSemana === 7) {
          const fechaString = formatDateLocal(d);
          const tieneData = listaSuplencias.value.some(s => s.FechaMapeada === fechaString);
          if (tieneData) {
            maxCols = Math.max(maxCols, diaSemana);
            if (maxCols === 7) break;
          }
        }
      }
      return maxCols;
    });

    const fechasAVisualizar = computed(() => {
      const fechasPeriodo = [];
      const inicio = parseDateLocal(periodoFiltroDesde.value);
      const dias = cantidadDiasPeriodo.value;
      const columnas = cantidadColumnas.value;

      for (let i = 0; i < dias; i++) {
        const d = new Date(inicio);
        d.setDate(inicio.getDate() + i);

        const fechaString = formatDateLocal(d);
        const diaSemana = d.getDay() === 0 ? 7 : d.getDay();
        const tieneData = listaSuplencias.value.some(s => s.FechaMapeada === fechaString);
        const esValido = diaSemana < 6 || tieneData;

        if (diaSemana <= columnas) {
          fechasPeriodo.push({
            dateObj: d,
            id: diaSemana,
            nombre: diasSemana.find(ds => ds.id === diaSemana)?.nombre || '',
            fecha: fechaString,
            fechaCorta: `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`,
            esValido: esValido
          });
        }
      }

      let primerIndice = fechasPeriodo.findIndex(f => f.esValido);
      let ultimoIndice = -1;
      for (let i = fechasPeriodo.length - 1; i >= 0; i--) {
        if (fechasPeriodo[i].esValido) {
          ultimoIndice = i;
          break;
        }
      }

      if (primerIndice === -1) return [];

      const fechasRecortadas = fechasPeriodo.slice(primerIndice, ultimoIndice + 1);
      const resultadoFinal = [];
      const primerDia = fechasRecortadas[0];

      if (primerDia.id > 1) {
        for (let i = 1; i < primerDia.id; i++) {
          const d = new Date(primerDia.dateObj);
          d.setDate(primerDia.dateObj.getDate() - (primerDia.id - i));
          resultadoFinal.push({
            id: i,
            nombre: diasSemana.find(ds => ds.id === i)?.nombre || '',
            fecha: formatDateLocal(d),
            fechaCorta: `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`
          });
        }
      }

      fechasRecortadas.forEach(f => {
        resultadoFinal.push({ id: f.id, nombre: f.nombre, fecha: f.fecha, fechaCorta: f.fechaCorta });
      });

      const ultimoDia = resultadoFinal[resultadoFinal.length - 1];
      if (ultimoDia.id < columnas) {
        const dObj = parseDateLocal(ultimoDia.fecha);
        for (let i = ultimoDia.id + 1; i <= columnas; i++) {
          const d = new Date(dObj);
          d.setDate(d.getDate() + (i - ultimoDia.id));
          resultadoFinal.push({
            id: i,
            nombre: diasSemana.find(ds => ds.id === i)?.nombre || '',
            fecha: formatDateLocal(d),
            fechaCorta: `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`
          });
        }
      }

      return resultadoFinal;
    });

    return {
      t,
      loading,
      errorPeriodoMaximo31Dias,
      errorDesdeNoMayorHasta,
      periodoFiltroDesde,
      periodoFiltroHasta,
      periodoFiltroDesdeTemp,
      periodoFiltroHastaTemp,
      cantidadColumnas,
      fechasAVisualizar,
      puedeAvanzar,
      puedeRetroceder,
      cambiarPeriodo,
      obtenerSuplenciasDia,
      noTieneSuplencias,
      hasVerSuplenciasPermission,
      fetchSuplencias,
      procesarCambioConDelay,
      formatearClases
    };
  }
};
</script>

<style scoped>
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
}
.fs-7 {
  font-size: 0.85rem;
}
.fs-8 {
  font-size: 0.75rem;
}
</style>